// eslint-disable-next-line import/prefer-default-export
export const groupBy = <T>(data: T[], selector: (v: T) => string): Map<string, T[]> => data.reduce((acc, datum) => {
  const group = selector(datum);
  acc.set(group, (acc.get(group) ?? []).concat(datum));
  return acc;
}, new Map() as Map<string, T[]>);

type Key = symbol | string | number;
interface TreeRecord<V> {
  [k: Key]: TreeRecord<V> | V;
}

function isTreeRecord<V>(x: TreeRecord<V>[keyof TreeRecord<V>]): x is TreeRecord<V> {
  return typeof x === 'object';
}

export function setAt<V>(target: TreeRecord<V>, path: Key[], v: TreeRecord<V> | V) {
  let current!: TreeRecord<V>;

  current = target;

  for (let i = 0; i < path.length - 1; i++) {
    const item = current[path[i]];
    if (item && isTreeRecord(item)) {
      current = item;
    } else if (!item) {
      const newObject: TreeRecord<V> = {};
      current[path[i]] = newObject;
      current = newObject;
    } else {
      current = { default: item };
      current[path[i]] = current;
    }
  }

  current[path[path.length - 1]] = v;
}

export function buildTree<V>(ob: Record<string, V>) {
  const target: Record<string, V | Record<string, V>> = {};

  // eslint-disable-next-line guard-for-in
  for (const key in ob) {
    setAt(target, key.toString().split('.'), ob[key.toString()]);
  }

  return target;
}

export function excludeKeys<T extends Record<string, unknown>, K extends(
keyof T)[]>(
  value: T,
  ...keys: K
) {
  return Object.fromEntries(
    Object.entries(value).flatMap(([k, v]) => (keys.includes(k) ? [[k, v]] : [])),
  ) as Omit<T, K[number]>;
}

export function range(start: number, end: number, step = 1) {
  const nums = [];
  for (let i = start; i < end; i += step) {
    nums.push(i);
  }
  return nums;
}
